import React, { useCallback } from 'react'
import { useAppSelector } from 'reduxTyped'
import { DatePicker, l } from '@manychat/manyui'

import { getBotTimezone } from 'common/core/selectors/appSelectors'
import { Field } from 'common/fields/entities/field'
import { FilterCondition } from 'common/filter/interfaces'
import {
  UserFieldDateTypes,
  UserFieldDateOptions,
} from 'common/filter/models/AudienceFilter/constants'
import { parseDateTimeWithBotTimezoneFromBackend } from 'common/usesList/utils'
import { Select } from 'components/forms/Select/Select'

import { DateFormula } from './components/DateFormula'

interface DateControlProps {
  condition: FilterCondition
  fieldDesc: Field
  allowDateFormula?: boolean
  onChange: (data: Partial<FilterCondition>, closePopover?: boolean) => void
  onChangeDatePicker: (event: React.ChangeEvent<HTMLInputElement>, closePopover?: boolean) => void
  onChangeGeneral: (event: React.ChangeEvent<HTMLInputElement>, closePopover?: boolean) => void
  onDelayCheckBoxChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const DateControl = ({
  condition,
  fieldDesc,
  allowDateFormula = false,
  onChange,
  onChangeDatePicker,
  onChangeGeneral,
  onDelayCheckBoxChange,
}: DateControlProps) => {
  const botTimezone = useAppSelector(getBotTimezone)

  const handleDateTypeChange = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>, closePopover?: boolean) => {
      const { value } = event.target
      onChange({ [UserFieldDateTypes.FORMULA]: value === UserFieldDateTypes.FORMULA }, closePopover)
    },
    [onChange],
  )

  const isFormula = UserFieldDateTypes.FORMULA in condition
  const type = isFormula ? UserFieldDateTypes.FORMULA : UserFieldDateTypes.SET

  const shouldDisableTime = fieldDesc.type === 'date' || fieldDesc.id === 'subscribed'

  return (
    <div className="p-a">
      <label className="text-secondary">{l.translate('Type')}</label>
      {allowDateFormula && (
        <>
          <Select
            key="date-type-select"
            className="m-t-xxs m-b-md"
            id="create-cuf-type"
            options={UserFieldDateOptions}
            value={type}
            onChange={handleDateTypeChange}
          />
          {isFormula && (
            <DateFormula
              condition={condition}
              fieldDesc={fieldDesc}
              onChange={onChange}
              onDelayCheckBoxChange={onDelayCheckBoxChange}
            />
          )}
        </>
      )}
      {!isFormula && (
        <div>
          <DatePicker
            value={
              botTimezone && !shouldDisableTime
                ? parseDateTimeWithBotTimezoneFromBackend(condition.value as string, botTimezone)
                : (condition.value as string) || ''
            }
            onChange={botTimezone && !shouldDisableTime ? onChangeDatePicker : onChangeGeneral}
            type={shouldDisableTime ? 'date' : 'datetime'}
          />
        </div>
      )}
    </div>
  )
}
